export const subscriptionText = {
    order_info: (date, nextBillingDate, isShipped) => `Your ${date} order ${isShipped ? "has shipped" : "is being processed"}. Any changes below will be applied to your next order, on ${nextBillingDate}. `,
    view_tracking_details: "View Tracking Details",
    your_subscription_title: "Your Subscription",
    total: "Total",
    box_will_be_delivered: (cadence) => `Your box will be delivered every ${cadence}`,
    in_your_box: "In Your Box",
    promo_component_note: "Promo Code",
    promo_note: "Note: One discount can be redeemed per order. See terms for details.",
    next_order_date: "Next Order Date",
    billing_date: "Billing Date",
    edit_box_note: "Tap 'Edit Your Box' to adjust your products, quantity, or flavors. All changes to this order must be made by",
    modify_order: "Modify Order",
    modify_order_note: "Select a new order date below. Your order will arrive 4-7 days after your order date.",
    snooze_order: "Snooze Order",
    snooze_order_note: "Delay or skip your order below. Your order will arrive 4-7 days after your order date.",
    skip_delivery: "Skip Order",
    skip_delivery_note: (date) => `Your next billing date will be ${date}. To lock in this new date, please select the reason you skipped.`,
    edit_your_box: "Edit Your Box",
    plan_type: "Plan Type",
    plan_type_subtitle: "How often do you want to receive shipments? ",
    modify_delivery_cadence: "Modify Delivery Cadence",
    modify_delivery_cadence_subtitle: "Select a new delivery cadence below. Your order will arrive 4-7 days after your order date.",
    delivery_frequency: "Delivery Frequency",
    reactivate_subscription_note: "Tap ‘Edit Your Box' to adjust your products, quantity, or flavors before reactivating your subscription.",
    get_it_now: "Get It Now",
    get_it_now_place_order: "Place a 1 off order today and receive your order in 4-7 business days.",
    get_it_now_note: "Note: This order is outside of your subscription cadence. ",
    get_it_now_next_order: (date) => `Your next subscription order will be placed on ${date}.`,
    in_your_subscription: "In Your Subscription",
    additional_product_get_it_now: "Add additional products from your subscription to your Get it Now order",
};
export const test = {};
